import { RegisterUsers } from "@/types/users"
import { SignUpFormData } from "../components/form/schemas"
import { removeCharacters } from "@/lib/custom-validations"

 export function mapFormToRegister(data: SignUpFormData): RegisterUsers {
    const register = new RegisterUsers()
    register.name = data.fullName
    register.document = removeCharacters(data.cpf)
    register.login = data.email
    register.password = data.password
    return register
  }